export const EMPLOYEE_COLUMNS = {
  firstname: 0,
  surname: 1,
  team: 2,
  email: 3,
  otherEmail: 4,
  countryCallingCode: 5,
  phoneNumber: 6,
  preferredContact: 7,
  surveyParticipant: 8,
  managerOfTeam: 9,
  language: 10,
};

export const TEAM_COLUMNS = {
  id: 0,
  name: 1,
  supervisorTeam: 2,
};

export enum ImportTab {
  EMPLOYEES = 'employees',
  TEAMS = 'teams',
}
